export const TEMPERATURAOGRANICENAKKT_V1ResourcesDE: TEMPERATURAOGRANICENAKKT_V1ResourcesBSInterface =
  {
    labelDone: "Datum der Aufgabenerledigung",
    errorMissingInput: "Bitte füllen Sie alle Felder aus",
    input: {
      signatureTitle: "Unterschrift",
      checkbox: {
        label:
          "Ich bestätige, dass ich darüber informiert wurde, dass die Temperatur nicht angemessen ist",
        name: "checkbox",
        placeholder: "Sie müssen dieses Feld akzeptieren",
      },
      datum: {
        label: "Bitte geben Sie das Datum ein",
        placeholder: "Bitte geben Sie das Datum ein",
        name: "datum",
      },
      ocitanaTemperatura: {
        label: "Abgelesene Temperatur",
        name: "ocitanaTemperatura",
        placeholder: "Bitte geben Sie die abgelesene Temperatur ein",
      },
      napomena: {
        label: "Notiz",
        name: "napomena",
        placeholder: "Bitte geben Sie eine Notiz ein",
      },
      korektivnaMjera: {
        label: "Korrekturmaßnahme",
        name: "korektivnaMjera",
        placeholder:
          "Bitte wählen Sie aus, ob eine Korrekturmaßnahme erforderlich ist",
      },
    },
    evidencijaForm: {
      buttonForward: "Unterschreiben",
      buttonBack: "Zurück",
    },
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
    dropdownKorektivnaMjera: {
      da: "Ja",
      ne: "Nein",
      undefined: "Bitte wählen Sie ein Feld aus",
    },
  };

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  napomena: InputField;
  checkbox: InputField;
  korektivnaMjera: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

export interface TEMPERATURAOGRANICENAKKT_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownKorektivnaMjera: IDropdownOptions;
}
